import { ReactElement } from "react";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { BuyerOrderListElement } from "./BuyerOrderListElement";
import { OrderListElementProps } from "./orderListElementTypes";
import { SupplierOrderListElement } from "./SupplierOrderListElement";

export default function OrderListElement(
  props: OrderListElementProps,
): ReactElement {
  const { business } = useSellarCurrentBusiness();

  return business?.Supplier ? (
    <SupplierOrderListElement {...props} />
  ) : (
    <BuyerOrderListElement {...props} />
  );
}
